// Admin entity-libraries + ingestion API — extends AdminAPI cleanly.
// All requests automatically attach the X-Workspace header so admin
// canonical reads/writes are correctly scoped.
import { AdminAPI } from '@/lib/admin-api';
import { api } from '@/lib/api';
import { getWorkspace } from '@/lib/workspace';

const wsHeaders = () => ({ 'X-Workspace': getWorkspace() });
const opts = () => ({ headers: wsHeaders() });

AdminAPI.entities = {
  transferPartners: ({ q, includeInactive } = {}) => {
    const sp = new URLSearchParams();
    if (q) sp.set('q', q);
    if (includeInactive) sp.set('include_inactive', 'true');
    return api.get(`/api/admin/entities/transfer-partners${sp.toString() ? '?' + sp.toString() : ''}`, opts());
  },
  loungePrograms: ({ q, includeInactive } = {}) => {
    const sp = new URLSearchParams();
    if (q) sp.set('q', q);
    if (includeInactive) sp.set('include_inactive', 'true');
    return api.get(`/api/admin/entities/lounge-programs${sp.toString() ? '?' + sp.toString() : ''}`, opts());
  },
  rewardCurrencies: ({ q, includeInactive } = {}) => {
    const sp = new URLSearchParams();
    if (q) sp.set('q', q);
    if (includeInactive) sp.set('include_inactive', 'true');
    return api.get(`/api/admin/entities/reward-currencies${sp.toString() ? '?' + sp.toString() : ''}`, opts());
  },
};

AdminAPI.ingest = {
  url: (url) => api.post('/api/admin/ingest/url', { url }, opts()),
  // Wave B: Bulk URL paste with soft dedupe. `force=true` re-ingests even
  // when a previous job exists for the same URL.
  urlsBulk: (urls, force = false) => api.post('/api/admin/ingest/urls/bulk', { urls, force }, opts()),
  // Wave B: PDF upload (max 20 MB, enforced server-side too).
  pdf: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return api.postForm('/api/admin/ingest/pdf', fd, opts());
  },
  list: ({ status, sourceType, limit = 50 } = {}) => {
    const sp = new URLSearchParams();
    if (status) sp.set('status', status);
    if (sourceType) sp.set('source_type', sourceType);
    sp.set('limit', String(limit));
    return api.get(`/api/admin/ingestion-jobs?${sp.toString()}`, opts());
  },
  get: (id) => api.get(`/api/admin/ingestion-jobs/${id}`, opts()),
  apply: (id, overrides = {}) => api.post(`/api/admin/ingestion-jobs/${id}/apply`, overrides, opts()),
  matchCandidates: (id, threshold = 0.7, limit = 5) =>
    api.get(`/api/admin/ingestion-jobs/${id}/match-candidates?threshold=${threshold}&limit=${limit}`, opts()),
};

export { AdminAPI };
